/** Omega's credential provider string, and the `/nodes/{provider}/...` route segment. */
export const MOMENTUM_PROVIDER = "momentum";

/**
 * `verification_failed` is Momentum refusing the login (or a blank field), so
 * the customer has something to fix. `failed` is everything else, network
 * included, and is worth a retry.
 */
export type MomentumConnectResult =
  | { ok: true }
  | { ok: false; reason: "verification_failed" | "failed" };

/** One entry from `GET /nodes/momentum/note-types`. `name` is what the node sends. */
export type MomentumNoteType = {
  id: string;
  name: string;
  insuranceAgencyId: string | null;
  createDate: string | null;
  changeDate: string | null;
};
